// An engine refusal as the marketer reads it (UI-4): the Hungarian sentence
// when the reason is one we know, and under it the engine's own words, as the
// log and the API have them — the reason, not a paraphrase of it.

import { ErrorState } from "@/components/emc/states";
import { engineSays } from "@/pages/segments/model";

export function EngineError({
  message,
  title,
  names,
  className,
}: {
  message: string;
  title?: string;
  names?: Map<string, string>;
  className?: string;
}) {
  const gloss = engineSays(message, names);
  return (
    <div className={className}>
      <ErrorState title={title} message={gloss ?? message} />
      {gloss && (
        <p className="mt-1.5 px-1 text-label break-words text-muted-foreground">
          A motor üzenete: <span className="data-mono">{message}</span>
        </p>
      )}
    </div>
  );
}

/** The same, for a toast's one line. */
export function engineLine(message: string, names?: Map<string, string>): string {
  return engineSays(message, names) ?? message;
}
